import React, { PureComponent } from 'react'
import styled from 'styled-components'
import FocusKeyContext from '@components/FocusKeyContext'

class Balloon extends PureComponent {
  getTopOffset(focusKey?: string) {
    if (focusKey) {
      const conspectParagraph = document.querySelector(`[data-draftjs-block-key="${focusKey}"]`)
      if (!conspectParagraph) return undefined
      const rect = conspectParagraph.getBoundingClientRect()
      return rect.top
    }
    return undefined
  }

  render() {
    return (
      <FocusKeyContext.Consumer>
        {({ focusKey }) => (
          <Text top={this.getTopOffset(focusKey)}>
            Что имеете в виду? Почему важно?<br />
            Как связано с пользой проекта? На что ещё влияет?<br />
            Почему важно сейчас?
          </Text>
        )}
      </FocusKeyContext.Consumer>
    )
  }
}
type TextProps = {
  top: number | undefined
}

const Text = styled<TextProps, any>('div')`
  background-color: #ccdff4;
  border-radius: 5px;
  box-sizing: content-box;
  font-size: 0.9em;
  left: 550px;
  line-height: 1.4em;
  padding: 0.5em 0.7em;
  position: absolute;
  top: calc(${p => (p.top != null ? p.top : 0)}px - 170px);
  transition: all 0.2s ease-out, top 0s;
  white-space: nowrap;
  width: 26em;
  z-index: 1;

  @media (max-width: 1357px) {
    left: 520px;
  }
  @media (max-width: 1250px) {
    left: 480px;
  }
  @media (max-width: 1115px) {
    left: 420px;
  }
  @media (max-width: 890px) {
    font-size: 0.82em;
  }
  @media (max-width: 812px) {
    font-size: 0.72em;
  }

  &:before {
    /* order of border is important */
    border: 0.625em solid transparent;
    border-right: 0.625em solid #ccdff4;
    content: '';
    left: -1.25em;
    position: absolute;
    top: 1.25em;
  }
`

export default Balloon



// WEBPACK FOOTER //
// ./src/components/Balloon/Balloon.tsx